export default __webpack_public_path__ + "etudiant.8c696ef.png";